module.exports = __webpack_public_path__ + "media/customizations/cherrycreektrail/logo-3d58cf5216146df442a136c44fcb2662.png";